export default function() {
	const videos: NodeListOf<HTMLVideoElement> = document.querySelectorAll('.home-hero__video');
	const reducedMotion: Boolean = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	if (videos && reducedMotion) {
		videos.forEach(video => {
			if (video instanceof HTMLVideoElement) {
				video.removeAttribute('autoplay');
				video.pause();
			}
		});
	}
}